import { render, staticRenderFns } from "./AggregatedAlertPanel.vue?vue&type=template&id=a33bef6c&scoped=true&"
import script from "./AggregatedAlertPanel.vue?vue&type=script&lang=js&"
export * from "./AggregatedAlertPanel.vue?vue&type=script&lang=js&"
import style0 from "./AggregatedAlertPanel.vue?vue&type=style&index=0&id=a33bef6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33bef6c",
  null
  
)

export default component.exports